const extraFormatPayload = (payload) => {
  return payload;
};

export default extraFormatPayload;
